import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const OdhadyPracnosti = {
	name: NAME,
	apiProvider,
	router,
};
